import { assertPackageVersion } from '@dynamic-labs-sdk/assert-package-version';

import {
  name as packageName,
  version as packageVersion,
} from '../../package.json';
assertPackageVersion(packageName, packageVersion);

export { addSolanaExtension } from '../addSolanaExtension';
export { NotSolanaProviderError } from '../errors/NotSolanaProviderError';
export { SponsorTransactionError } from '../errors/SponsorTransactionError/SponsorTransactionError';
export { getSolanaConnection } from '../getSolanaConnection';
export { isSolanaNetworkProvider } from '../isSolanaNetworkProvider';
export { isSolanaWalletAccount } from '../isSolanaWalletAccount';
export { simulateSolanaTransaction } from '../simulateSolanaTransaction';
export type {
  SolanaSimulationResult,
  SolanaTransactionFeeData,
} from '../transactionSimulation.types';

export { isSolanaGasSponsorshipEnabled } from '../isSolanaGasSponsorshipEnabled';
export { addPhantomRedirectSolanaExtension } from '../phantomRedirect/addPhantomRedirectSolanaExtension';
export { completePhantomRedirect } from '../phantomRedirect/completePhantomRedirect';
export { detectPhantomRedirect } from '../phantomRedirect/detectPhantomRedirect';
export type {
  PhantomRedirectWalletProvider,
  PhantomSession,
} from '../phantomRedirect/PhantomRedirectWalletProvider.types';
export { signAllTransactions } from '../signAllTransactions';
export { signAndSendSponsoredTransaction } from '../signAndSendSponsoredTransaction';
export { signAndSendTransaction } from '../signAndSendTransaction';
export { signTransaction } from '../signTransaction';
export type { SolanaNetworkProvider } from '../SolanaNetworkProvider.types';
export type { SolanaWalletAccount } from '../SolanaWalletAccount.types';
export { calculateSolanaTransactionFee } from '../utils/calculateSolanaTransactionFee';
